import { Stepper } from "@mantine/core";
import { usePOAStepsStore } from "../../hooks/ui/";
import { ENUMPOASteps } from "../../hooks/ui/poaStepsDataStore";
import { useEffect, useState } from "react";
import classes from "./index.module.css";

export default function POAStepper({
  renewal = false,
}: { renewal?: boolean } = {}) {
  const { currentStep } = usePOAStepsStore();
  const [stepperStep, setStepperStep] = useState(0);

  useEffect(() => {
    if (renewal) {
      switch (currentStep) {
        case ENUMPOASteps.POAINFO:
          setStepperStep(0);
          break;
        case ENUMPOASteps.POADURATION:
          setStepperStep(1);
          break;
        case ENUMPOASteps.POACONFIRMATION:
        case ENUMPOASteps.POASIGN:
          setStepperStep(2);
          break;
        case ENUMPOASteps.CONFIRMATION:
          setStepperStep(3);
          break;
        default:
          break;
      }
    } else {
      switch (currentStep) {
        case ENUMPOASteps.IDENTIFY:
          setStepperStep(0);
          break;
        case ENUMPOASteps.EMAILANDPHONE:
          setStepperStep(1);
          break;
        case ENUMPOASteps.POAINFO:
        case ENUMPOASteps.POADURATION:
        case ENUMPOASteps.POACONFIRMATION:
        case ENUMPOASteps.POASIGN:
          setStepperStep(2);
          break;
        case ENUMPOASteps.BOOKMEETING:
          setStepperStep(3);
          break;
        case ENUMPOASteps.POASUMMARY:
          setStepperStep(4);
          break;
        default:
          break;
      }
    }
  }, [currentStep, renewal]);

  const bookMeetingEnabled = import.meta.env.VITE_BOOK_MEETING_ENABLED;

  const renewalSteps = [
    { label: "Information", icon: "1" },
    { label: "Giltighet", icon: "2" },
    { label: "Signering", icon: "3" },
    { label: "Bekräftelse", icon: "4" },
  ];

  const normalSteps = [
    { label: "Identifiering", icon: "1" },
    { label: "Kontaktuppgifter", icon: "2" },
    { label: "Lämna fullmakt", icon: "3" },
    ...(bookMeetingEnabled ? [{ label: "Boka rådgivning", icon: "4" }] : []),
  ];

  const stepsToRender = renewal ? renewalSteps : normalSteps;

  return (
    <Stepper
      key={renewal ? "renewal" : "normal"}
      active={stepperStep}
      mt="xl"
      mb="xl"
      size="sm"
      iconSize={42}
      classNames={{
        root: classes.root,
      }}
    >
      {stepsToRender.map((step) => (
        <Stepper.Step key={step.label} label={step.label} icon={step.icon} />
      ))}
    </Stepper>
  );
}
